import React, { useState } from "react";
import { getToken } from "../../utils/common";
import { VakTestData } from "../../typings/vak";
import Button from "../UI/Button";
import { Download } from "lucide-react";

interface VakPdfDownloadProps {
  testId: number;
  testData?: VakTestData;
  testDate?: string;
  studentName?: string;
}

const VakPdfDownload: React.FC<VakPdfDownloadProps> = ({
  testId,
  testData,
  testDate,
  studentName,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setIsDownloading(true);
    setError(null);

    try {
      const token = getToken();

      // Prepare request body with recommendations data
      const requestBody = {
        testId,
        testDate: testDate || testData?.created_at,
        studentName: studentName,
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/vak/download-pdf/${testId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `SLP-Result-${testId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to download PDF");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="riasec-pdf-download w-full">
      <Button
        block
        className="gradient-accent"
        onClick={handleDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <>
            <span
              className="animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 w-4 h-4 mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            Mengunduh...
          </>
        ) : (
          <>
            <Download /> Download PDF
          </>
        )}
      </Button>

      {error && (
        <div className="p-4 rounded border bg-red-50 border-red-200 text-red-800 mt-2 mb-0">
          <small>File PDF Belum Tersedia</small>
        </div>
      )}
    </div>
  );
};

export default VakPdfDownload;
